module.exports = __webpack_public_path__ + "img/home.91174654.jpg";